<template>
    <div id="app">
      <div class="admin-chat-container">
        <h2>Group Members</h2>
        
        <!-- Button to fetch administrators and total member count -->
        <button @click="fetchGroupDetails" :disabled="isLoading">Fetch Group Details</button>
        
        <!-- Loading indicator while fetching data -->
        <div v-if="isLoading">Loading...</div>
        
        <!-- Displaying members count -->
        <div v-if="membersCount !== null">Total Members: {{ membersCount }}</div>
  
        <!-- Displaying administrators -->
        <div v-if="admins.length > 0">
          <h3>Administrators:</h3>
          <ul>
            <li v-for="admin in admins" :key="admin.user.id">
              {{ admin.user.first_name }} ({{ admin.user.username }})
            </li>
          </ul>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    name: 'App',
    data() {
      return {
        botToken: '7843663557:AAHHntn1bPWuazRlNwiiJEgVjGz2wkeMhO4', // Bot Token
        chatId: '-1002499340521', // Group Chat ID
        admins: [], // List of administrators
        membersCount: null, // Total number of members in the group
        isLoading: false, // Loading state
      };
    },
    methods: {
      async fetchGroupDetails() {
        this.isLoading = true;
        this.admins = [];
        this.membersCount = null;
        
        // Fetch total number of members
        const membersCountUrl = `https://api.telegram.org/bot${this.botToken}/getChatMembersCount`;
        try {
          const membersResponse = await axios.post(membersCountUrl, {
            chat_id: this.chatId,
          });
          this.membersCount = membersResponse.data.result;
        } catch (error) {
          console.error('Error fetching members count:', error);
        }
        
        // Fetch group administrators
        const adminsUrl = `https://api.telegram.org/bot${this.botToken}/getChatAdministrators`;
        try {
          const adminsResponse = await axios.post(adminsUrl, {
            chat_id: this.chatId,
          });
          this.admins = adminsResponse.data.result;
        } catch (error) {
          console.error('Error fetching administrators:', error);
        } finally {
          this.isLoading = false;
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .admin-chat-container {
    width: 100%;
    max-width: 600px;
    margin: 50px auto;
    text-align: center;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 8px;
    background-color: #f9f9f9;
  }
  
  button {
    padding: 10px 20px;
    font-size: 16px;
    background-color: #4CAF50;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  button:disabled {
    background-color: #ccc;
  }
  
  h3 {
    margin-top: 20px;
  }
  
  ul {
    list-style-type: none;
    padding: 0;
  }
  
  li {
    margin: 5px 0;
  }
  </style>